import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  template: `
  <h2 mat-dialog-title>{{ 'CONS_DUBAI.CONFIRM_DELETE_TITLE' | translate }}</h2>
  <mat-dialog-content>
    <p>{{ data.message }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">{{ 'CONS_DUBAI.CONFIRM_NO' | translate }}</button>
    <button mat-button color="warn" (click)="confirm()">{{ 'CONS_DUBAI.CONFIRM_YES' | translate }}</button>
  </mat-dialog-actions>
`,
  styles: [`
    mat-dialog-actions {
      display: flex;
      justify-content: flex-end;
    }
  `]
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
